import React, { useState } from 'react';
import { FaEdit, FaSave, FaPlus, FaTrashAlt } from 'react-icons/fa';

export default function DashboardDirectiva({ 
    parametrosSL, 
    gastos, 
    setGastos, 
    metaParques, 
    setMetaParques, 
    diasLaborables,
    setDiasLaborables,
    horasDiarias,
    setHorasDiarias,
    departamentos,
    setDepartamentos,
    totalGastosMensuales, 
    prorrateoHoraAutonomo 
}) {
    const [isEditing, setIsEditing] = useState(false);

    const handleGastoChange = (id, field, value) => {
        setGastos(gastos.map(g => g.id === id ? { ...g, [field]: value } : g));
    };

    const addGasto = () => {
        setGastos([...gastos, { id: Date.now(), nombre: 'Nuevo Gasto', monto: 0 }]);
    };

    const removeGasto = (id) => {
        setGastos(gastos.filter(g => g.id !== id));
    };

    const formatCurrency = (value) => Number(value).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
    const formatPercent = (value) => (Number(value) * 100).toFixed(0) + '%';

    return (
        <div className="w-full mb-6">
            <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold text-gray-800">Motor Financiero Autónomo</h3>
                <button
                    onClick={() => setIsEditing(!isEditing)}
                    className={`flex items-center gap-2 px-4 py-2 text-sm font-bold rounded shadow-sm transition-colors ${isEditing ? 'bg-green-600 hover:bg-green-800 text-white' : 'bg-blue-900 hover:bg-blue-800 text-white'}`}
                >
                    {isEditing ? <><FaSave /> Guardar Ecosistema</> : <><FaEdit /> Editar Variables</>}
                </button>
            </div>

            {/* Cuadrícula Limpia de 4 KPIs Principales - EXTIRPADA LA CASILLA DE HORAS POR PARQUE */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 border-l-4 border-l-blue-900">
                    <p className="text-[10px] text-gray-500 font-bold uppercase">Gasto Fijo Mensual</p>
                    <p className="text-xl font-bold text-gray-800">{formatCurrency(totalGastosMensuales)}</p>
                </div>
                
                <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 border-l-4 border-l-purple-600">
                    <p className="text-[10px] text-gray-500 font-bold uppercase">Meta Producción</p>
                    {isEditing ? (
                        <input type="number" className="w-full mt-1 p-1 border border-purple-300 rounded text-lg font-bold outline-none focus:border-purple-600" value={metaParques} onChange={e => setMetaParques(Number(e.target.value))} />
                    ) : (
                        <p className="text-lg font-bold text-purple-700">{metaParques} Parques</p>
                    )}
                </div>

                <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 border-l-4 border-l-red-600">
                    <p className="text-[10px] text-gray-500 font-bold uppercase">Prorrateo / Hora Real</p>
                    <p className="text-xl font-bold text-red-600">{formatCurrency(prorrateoHoraAutonomo)}</p>
                </div>

                <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 border-l-4 border-l-teal-600">
                    <p className="text-[10px] text-gray-500 font-bold uppercase">Margen Neto</p>
                    <p className="text-xl font-bold text-teal-700">{formatPercent(parametrosSL?.margenBeneficioDeseado || 0.20)}</p>
                </div>
            </div>

            {/* Sección de inputs ocultos en modo edición para calibrar la capacidad técnica en el fondo */}
            {isEditing && (
                <div className="bg-blue-50 p-4 rounded-lg border border-blue-200 mb-6 grid grid-cols-1 md:grid-cols-3 gap-4 animate-in slide-in-from-top-2 duration-300">
                    <div>
                        <label className="block text-[10px] font-bold text-blue-800 uppercase mb-1">Días Laborables al Mes</label>
                        <input type="number" className="w-full p-2 border border-blue-300 rounded text-sm bg-white font-semibold outline-none focus:border-blue-600" value={diasLaborables} onChange={e => setDiasLaborables(Number(e.target.value))} />
                    </div>
                    <div>
                        <label className="block text-[10px] font-bold text-blue-800 uppercase mb-1">Horas de Jornada Diaria</label>
                        <input type="number" className="w-full p-2 border border-blue-300 rounded text-sm bg-white font-semibold outline-none focus:border-blue-600" value={horasDiarias} onChange={e => setHorasDiarias(Number(e.target.value))} />
                    </div>
                    <div>
                        <label className="block text-[10px] font-bold text-blue-800 uppercase mb-1">Secciones / Departamentos</label>
                        <input type="number" className="w-full p-2 border border-blue-300 rounded text-sm bg-white font-semibold outline-none focus:border-blue-600" value={departamentos} onChange={e => setDepartamentos(Number(e.target.value))} />
                    </div>
                </div>
            )}

            {/* Desglose de Gastos Fijos */}
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
                <div className="flex justify-between items-center mb-4">
                    <h4 className="text-xs font-bold text-gray-700">Desglose de Gastos Fijos</h4>
                    {isEditing && (
                        <button onClick={addGasto} className="text-xs flex items-center gap-1 bg-blue-100 text-blue-800 px-3 py-1 rounded hover:bg-blue-200 font-bold transition-colors">
                            <FaPlus /> Añadir Rubro
                        </button>
                    )}
                </div>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    {gastos.map((g) => (
                        <div key={g.id} className="flex items-center justify-between border-b border-gray-100 py-2">
                            {isEditing ? (
                                <>
                                    <input type="text" className="text-[10px] w-1/2 p-1 border border-gray-300 rounded mr-2 outline-none focus:border-blue-500" value={g.nombre} onChange={(e) => handleGastoChange(g.id, 'nombre', e.target.value)} />
                                    <input type="number" step="0.01" className="text-[10px] font-bold w-1/3 p-1 border border-gray-300 rounded text-right outline-none focus:border-blue-500" value={g.monto} onChange={(e) => handleGastoChange(g.id, 'monto', e.target.value)} />
                                    <button onClick={() => removeGasto(g.id)} className="text-red-500 ml-2 hover:text-red-700 transition-colors"><FaTrashAlt size={12}/></button>
                                </>
                            ) : (
                                <>
                                    <span className="text-[11px] text-gray-600">{g.nombre}</span>
                                    <span className="text-[11px] font-bold text-gray-900">{formatCurrency(g.monto)}</span>
                                </>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}